module.exports = __webpack_public_path__ + "img/image_gallery4.0c76f6c5.jpg";